import { render, staticRenderFns } from "./OpenInDashRecordingsBtn.vue?vue&type=template&id=2ecbd767"
import script from "./OpenInDashRecordingsBtn.vue?vue&type=script&lang=js"
export * from "./OpenInDashRecordingsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports